module.exports = __webpack_public_path__ + "img/auto_spin_btn.ac50a66a.png";